import { useSuiClient } from '@mysten/dapp-kit';
import { useState } from 'react';
import { useDebounce } from 'react-use';
import type { ParrotCoinStruct } from 'src/types';
import { useParrotCoins } from './use-parrot-coins';

export const useParrotSearchCoin = (value: string) => {
  const client = useSuiClient();
  const { coins: allCoins } = useParrotCoins();
  const [coins, setCoins] = useState<ParrotCoinStruct[]>([]);
  const [loading, setLoading] = useState(false);

  useDebounce(
    async () => {
      if (!value) {
        setCoins(allCoins);
        return;
      }
      setLoading(true);
      if (/^0x([A-Za-z\d]+)::([A-Za-z\d_]+)::([A-Za-z\d_]+)$/.test(value)) {
        try {
          const coinMetadata = await client.getCoinMetadata({
            coinType: value,
          });
          if (coinMetadata) {
            setCoins([
              {
                ...coinMetadata,
                type: value,
              },
            ]);
            return;
          }
        } catch (err) {
          setCoins([]);
        }
      } else {
        const searchCoins = allCoins.filter(
          (coin) => coin.symbol.toLowerCase().indexOf(value.toLowerCase()) > -1,
        );
        setCoins(searchCoins);
      }

      setLoading(false);
    },
    180,
    [value, client, JSON.stringify(allCoins)],
  );

  return { coins, loading };
};
